module.exports = __webpack_public_path__ + "static/media/similMaderaHaya.56459ed1.jpg";